import { useContext, createContext, useEffect, useState } from 'react'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { db, auth } from '../firebase';

const AuthContext = createContext()

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState()
    const [userDoc, setUserDoc] = useState()
    const [loading, setLoading] = useState(true)

    // check for user on load
    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged(async (user) => {
        setCurrentUser(user);
        console.log(user)
        setLoading(false);
      });
      
      return unsubscribe
      
    }, [])

    // register or signup user function
    async function signup(email, password) {
        createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in 
          const user = userCredential.user;
          setCurrentUser(user)
        })
    }

    // sign in or login user function
    async function signin(email, password) {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        setCurrentUser(user);
      } catch (error) {
        console.log(error);
        throw error; // rethrow the error to be caught by the try-catch block in the login function
      }
    }

    // sign out or log out user
    async function signout() {
        signOut(auth).then(() => {
            // Sign-out successful.
        setCurrentUser()
          })
    }

  return (
    <AuthContext.Provider value={{signup, signin, signout, currentUser, userDoc, setUserDoc}}>
        {!loading && children }
    </AuthContext.Provider>
  )
}

export const UserAuth = () => {
    return useContext(AuthContext)
}

